import { render } from "./WinBadge.vue?vue&type=template&id=d36a5bb0&scoped=true"
import script from "./WinBadge.vue?vue&type=script&lang=js"
export * from "./WinBadge.vue?vue&type=script&lang=js"

import "./WinBadge.vue?vue&type=style&index=0&id=d36a5bb0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d36a5bb0"]])

export default __exports__